import React, { useState } from "react";
import styles from "./Objects.module.scss";
import { Search } from "../../../../shared/Search/Search";
import { SortBy } from "../../../../shared/SortBy/SortBy";
import { FolderList } from "./components/FolderList/FolderList";
import { ObjectList } from "./components/ObjectList/ObjectList";
import { LoaderWithoutText } from "../../../../shared/LoaderWithoutText/LoaderWithoutText";
import { useAppSelector } from "../../../../redux/store";
import { getIsShowInnerLoader } from "../../../../redux/reducers/app/appSelectors";
import { SearchObjects } from "./components/SearchObjects/SearchObjects";

export const Objects: React.FC = () => {
  const [sortValue, setSortValue] = useState(0);
  const { isShowEnvironmentLoader } = useAppSelector(getIsShowInnerLoader());

  if (isShowEnvironmentLoader) {
    return <LoaderWithoutText />;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.search_wrapper}>
          <SearchObjects />
        </div>
        <SortBy value={sortValue} setValue={setSortValue} />
      </div>
      <FolderList />
      <ObjectList sortValue={sortValue} />
    </div>
  );
};
